// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel_content[data-v-70acedf8] {\n  display: inline-block;\n  width: 3.229167rem;\n  height: 2.708333rem;\n}\n.carousel_content .carouselItem[data-v-70acedf8] {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n}\n.carousel_content .carouselItem img[data-v-70acedf8] {\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
